import {LocationDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'DELETE_CUSTOMER_CATEGORY';

export async function deleteLocation(
    userData: Record<string, string>,
    locationId: number
) {
    try {
        const result = await LocationDao.deleteLocation(userData.userToken, locationId);

        return result;
    }
    catch (error: any) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la localisation',
            error: error
        });
    }
}
